import './card-store-compact.scss';
import './jquery.matchHeight';

export default () => {
	$( '.card-store__top' ).matchHeight();
};
